
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dZPDC", function(module, exports) {

var $4MiWC = parcelRequire("4MiWC");


var $9CzW0 = parcelRequire("9CzW0");

const $4e3b9b5f05e99dc1$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'archiveTeam',
    'unarchiveTeam',
    'unlinkTeamFromGroup',
    'isSingleFullMemberTeam',
    'createTeam',
    'createTeamContainers',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getRecommendedUsers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack',
    'getUserTenure',
    'getAriFromUrl',
    'getWebLinkTitle',
    'addAgentToTeam',
    'getTeamEnabledSites',
    'assignTeamsToSites',
    'removeAgentTeamAssociation',
    'getAssignedTeams',
    'setTeamSiteAssignmentPermission',
    'getUnassignedTeams',
    'getTeamSiteAssignmentOrgDetails',
    'getTeamsToBeClonedToJsmSites',
    'getReportingLines'
];
const $4e3b9b5f05e99dc1$export$879344107b04120c = new Map([
    ...$4e3b9b5f05e99dc1$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $9CzW0.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $4MiWC.ExperienceTypes).Operation,
                performanceType: (0, $4MiWC.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);


/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $beNe1 = parcelRequire("beNe1");


var $lcNLp = parcelRequire("lcNLp");




const $9f5dbc5cc1041e65$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $lcNLp.USER_ARI_PREFIX));


const $9cecde14697f860a$export$1d0eef1d33b05366 = (ari)=>{
    if ((0, $9f5dbc5cc1041e65$export$caac29844ad91f64)(ari)) return ari.replace((0, $lcNLp.USER_ARI_PREFIX), '');
    throw new Error('Invalid UserARI');
};



var $1ystj = parcelRequire("1ystj");


var $keJGW = parcelRequire("keJGW");


var $DtqR5 = parcelRequire("DtqR5");


var $bsEAi = parcelRequire("bsEAi");


var $1epkm = parcelRequire("1epkm");


var $aVnuX = parcelRequire("aVnuX");

function $88cd0e47746db4bb$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}



var $asQBE = parcelRequire("asQBE");


var $gvPaz = parcelRequire("gvPaz");


var $38Dpg = parcelRequire("38Dpg");




async function $f7465175792d6e12$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
            ...options.headers || {}
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $DtqR5.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((_resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $DtqR5.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}


async function $bfd4e200a6bcd4a3$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $38Dpg.withExponentialBackoff)((0, $f7465175792d6e12$export$93d33e3b46bf00e7), {
        initial: (0, $aVnuX.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $aVnuX.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $aVnuX.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $88cd0e47746db4bb$export$81f27058be86d7ea)(data) && (0, $asQBE.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $gvPaz.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $1epkm.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}


/**
 * Validates that a siteId (cloudId) conforms to the format expected by
 * PlatformSiteAri from `@atlassian/ari/platform`.
 *
 * We inline this instead of importing `@atlassian/ari` because that package
 * is private and `teams-client` is a public package - public packages cannot
 * depend on private packages.
 *
 * The regex matches the `resourceIdSegmentFormats.siteId` rule from the
 * PlatformSiteAri manifest: `/[a-zA-Z0-9_\-.]{1,255}/`
 */ const $c7e7d5b8af685409$var$SITE_ID_PATTERN = /^[a-zA-Z0-9_\-.]{1,255}$/;
function $c7e7d5b8af685409$var$createPlatformSiteAri(siteId) {
    if (!$c7e7d5b8af685409$var$SITE_ID_PATTERN.test(siteId)) throw new Error(`Invalid siteId: ${siteId}`);
    return `ari:cloud:platform::site/${siteId}`;
}
class $c7e7d5b8af685409$export$42f6d6baced34b2d extends (0, $bsEAi.BaseClient) {
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    /**
   * Creates query context headers if cloudId is available and valid.
   * Validates the cloudId before constructing the ARI, preventing invalid
   * ARIs like `ari:cloud:platform::site/None` from being sent.
   */ createQueryContextHeaders(cloudId) {
        if (!cloudId) return undefined;
        try {
            const ari = $c7e7d5b8af685409$var$createPlatformSiteAri(cloudId);
            return {
                'X-Query-Context': ari
            };
        } catch  {
            return undefined;
        }
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            // Automatically add X-Query-Context header if cloudId is available in context
            const cloudId = this.getCloudId();
            const queryContextHeaders = this.createQueryContextHeaders(cloudId);
            // Merge headers: query context headers first, then provided headers (provided headers take precedence)
            const mergedOptions = {
                ...options,
                headers: {
                    ...queryContextHeaders,
                    ...options.headers
                }
            };
            return (0, $bfd4e200a6bcd4a3$export$7feffc86760ee7ce)(this.serviceUrl, body, mergedOptions);
        } catch (error) {
            if (error instanceof (0, $DtqR5.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $keJGW.DefaultError)({});
        }
    }
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = void 0;
        this.serviceUrl = serviceUrl;
    }
}



var $hAdDP = parcelRequire("hAdDP");


var $bPh6H = parcelRequire("bPh6H");


var $iLX84 = parcelRequire("iLX84");

const $fc9327803055d04b$export$74f3ccf149f124b = (0, $bPh6H.print)((0, $iLX84.default)`mutation unlinkTeamToContainerMutation($teamId:ID!$containerId:ID!){graphStore@optIn(to:["GraphStoreMutation"]){deleteTeamConnectedToContainer(input:{relationships:[{from:$teamId to:$containerId}]})@optIn(to:["GraphStoreTeamConnectedToContainer"]){errors{message extensions{statusCode errorType}}success}}}`);








const $70443ab0e8a17fd1$export$6c9c309d551311e = (0, $bPh6H.print)((0, $iLX84.default)`query getNumberOfTeamsForContainer($containerId:ID!){graphStore@optIn(to:"GraphStore"){teamConnectedToContainerInverse(id:$containerId consistentRead:true)@optIn(to:"GraphStoreTeamConnectedToContainer"){edges{id}}}}`);








const $0aa460292efdfea7$export$8e179b6008492526 = (0, $bPh6H.print)((0, $iLX84.default)`query getTeamsForContainer($containerId:ID!){graphStore@optIn(to:"GraphStore"){teamConnectedToContainerInverse(id:$containerId consistentRead:true)@optIn(to:"GraphStoreTeamConnectedToContainer"){edges{node{...on TeamV2{id description displayName creator{id}smallAvatarImageUrl smallHeaderImageUrl largeAvatarImageUrl largeHeaderImageUrl members{nodes{member{id name picture accountStatus ...on AtlassianAccountUser{extendedProfile{jobTitle}}...on AppUser{appType}}role state}pageInfo{endCursor hasNextPage}}organizationId membershipSettings isVerified state}}}}}}`);








const $fd8ebe20e46d9d87$export$dc2f639827051505 = (0, $bPh6H.print)((0, $iLX84.default)`query TeamContainersQueryV2($cypherQuery:String!$params:JSON!){graphStore@optIn(to:["GraphStore" "GraphStoreCypherQueryV2"]){cypherQueryV2(query:$cypherQuery params:$params){edges{node{columns{key value{...on GraphStoreCypherQueryV2AriNode{data{__typename ...on ConfluenceSpace{id confluenceSpaceName:name type createdDate links{base webUi}icon{path}}...on JiraProject{id jiraProjectName:name webUrl created avatar{medium}projectType projectTypeName}...on LoomSpace{id loomSpaceName:name url}}}}}}}}}}`);








const $fdfb764284b5933a$export$5a63c9c7b444f1f5 = (0, $bPh6H.print)((0, $iLX84.default)`query serviceName_TeamHasAgentsQuery($id:ID!){graphStore@optIn(to:"GraphStore"){teamHasAgents(id:$id)@optIn(to:"GraphStoreTeamHasAgents"){edges{node{...on AppUser{id name picture}}cursor}pageInfo{hasNextPage endCursor}}}}`);


const $a6bcad654ef2bc35$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $a6bcad654ef2bc35$export$2e2bcd8739ae039 = $a6bcad654ef2bc35$var$TeamMembershipQuery;








const $414d9558e0e686a4$export$9963ed3cbf7b791c = (0, $bPh6H.print)((0, $iLX84.default)`query TeamsUserQuery($userId:ID!){user(accountId:$userId){id name picture accountStatus __typename ...on AtlassianAccountUser{email nickname locale zoneinfo extendedProfile{jobTitle organization department location phoneNumbers{type value}closedDate inactiveDate}}...on CustomerUser{email locale zoneinfo}...on AppUser{appType}}}`);


function $c2eaa446ffecafba$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}


class $81bcc742addbac25$export$b44e5dafe13af7b3 extends (0, $c7e7d5b8af685409$export$42f6d6baced34b2d) {
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $a6bcad654ef2bc35$export$2e2bcd8739ae039),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $9cecde14697f860a$export$1d0eef1d33b05366)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $9cecde14697f860a$export$1d0eef1d33b05366)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $c2eaa446ffecafba$export$6b53fef091c7e27d)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $414d9558e0e686a4$export$9963ed3cbf7b791c),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
    async queryTeamHasAgents(teamId) {
        const teamAri = (0, $beNe1.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $fdfb764284b5933a$export$5a63c9c7b444f1f5),
            variables: {
                id: teamAri
            }
        }, {
            operationName: 'TeamHasAgentsQuery'
        });
        return this.processTeamHasAgentsResponse(teamId, response.graphStore);
    }
    processTeamHasAgentsResponse(teamId, response) {
        return response.teamHasAgents.edges.map(({ node: node })=>({
                associationId: {
                    teamId: teamId,
                    accountId: (0, $9cecde14697f860a$export$1d0eef1d33b05366)(node.id)
                },
                agent: {
                    id: node.id,
                    fullName: node.name,
                    avatarUrl: node.picture
                }
            }));
    }
    async getTeamContainers(teamId) {
        const teamAri = (0, $beNe1.toTeamARI)(teamId);
        const cypherQuery = `MATCH (team:IdentityTeam {ari: '${teamAri}'})-[:team_connected_to_container]->(container) RETURN container`;
        const response = await this.makeGraphQLRequest({
            query: (0, $fd8ebe20e46d9d87$export$dc2f639827051505),
            variables: {
                cypherQuery: cypherQuery,
                params: {
                    id: teamAri
                }
            }
        }, {
            operationName: 'TeamContainersQueryV2'
        });
        return this.processV2Response(response);
    }
    processV2Response(response) {
        const containersResult = response.graphStore.cypherQueryV2.edges.reduce((containers, edge)=>{
            edge.node.columns.forEach((column)=>{
                const containerData = column.value?.data;
                if (!containerData) return;
                if (containerData?.__typename === 'ConfluenceSpace') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.confluenceSpaceName || '',
                    icon: `${containerData.links.base}${containerData.icon.path}`,
                    createdDate: new Date(containerData.createdDate),
                    link: `${containerData.links.base}${containerData.links.webUi}`,
                    containerTypeProperties: {
                        subType: undefined,
                        name: undefined
                    }
                });
                else if (containerData?.__typename === 'JiraProject') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.jiraProjectName,
                    icon: containerData.avatar.medium,
                    createdDate: new Date(containerData.created),
                    link: containerData.webUrl,
                    containerTypeProperties: {
                        subType: containerData.projectType || '',
                        name: containerData.projectTypeName || ''
                    }
                });
                else if (containerData?.__typename === 'LoomSpace') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.loomSpaceName,
                    icon: '',
                    link: containerData.url
                });
            });
            return containers;
        }, []);
        return containersResult;
    }
    async unlinkTeamContainer(teamId, containerId) {
        const teamAri = (0, $beNe1.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $fc9327803055d04b$export$74f3ccf149f124b),
            variables: {
                containerId: containerId,
                teamId: teamAri
            }
        }, {
            operationName: 'UnlinkContainerMutation'
        });
        return response.graphStore;
    }
    async queryNumberOfTeamConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $70443ab0e8a17fd1$export$6c9c309d551311e),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'NumberOfTeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.length;
    }
    async queryTeamsConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $0aa460292efdfea7$export$8e179b6008492526),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'TeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.map(({ node: node })=>({
                id: node.id,
                displayName: node.displayName,
                description: node.description,
                state: node.state,
                membershipSettings: node.membershipSettings,
                organizationId: node.organizationId,
                creatorId: node.creator?.id,
                isVerified: node.isVerified,
                members: node.members?.nodes.map(({ member: member })=>({
                        id: member?.id ? (0, $9cecde14697f860a$export$1d0eef1d33b05366)(member?.id) : '',
                        fullName: member?.name ?? '',
                        avatarUrl: member?.picture,
                        status: member?.accountStatus
                    })) ?? [],
                includesYou: false,
                // to-do - this needs to be computed - https://product-fabric.atlassian.net/browse/CCECO-4368
                memberCount: node.members?.nodes.length ?? 0,
                largeAvatarImageUrl: node.largeAvatarImageUrl,
                smallAvatarImageUrl: node.smallAvatarImageUrl,
                largeHeaderImageUrl: node.largeHeaderImageUrl,
                smallHeaderImageUrl: node.smallHeaderImageUrl,
                restriction: 'ORG_MEMBERS' // deprecated field, kept for backwards compatibility
            }));
    }
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
}
const $81bcc742addbac25$export$464c991dbf0b2393 = new $81bcc742addbac25$export$b44e5dafe13af7b3((0, $1ystj.DEFAULT_CONFIG).stargateRoot, {
    logException: $hAdDP.logException
});






var $8cYxi = parcelRequire("8cYxi");

var $1bf5f09d5eaafe21$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($1bf5f09d5eaafe21$var$CONTAINER_TYPE || {});
var $1bf5f09d5eaafe21$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($1bf5f09d5eaafe21$var$ENTITY_TYPE || {});
class $1bf5f09d5eaafe21$export$cd5b4a06db0ea4e2 extends (0, $8cYxi.RestClient) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
    getRecommendedUsers({ accountId: accountId, cloudId: cloudId, maxNumberOfResults: maxNumberOfResults = 12, filter: filter = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:"app")' }) {
        return this.postResource('/v2/recommend/user', {
            context: {
                userId: accountId,
                tenantId: cloudId
            },
            modelRequestParams: {
                experience: 'CgUserNearbyUser',
                caller: 'atlas'
            },
            requestingUserId: accountId,
            expand: 'existing',
            maxNumberOfResults: maxNumberOfResults,
            filter: filter
        });
    }
}


const $aa879c001d66f150$var$_default_1 = new (0, $1bf5f09d5eaafe21$export$cd5b4a06db0ea4e2)({
    serviceUrl: (0, $1ystj.DEFAULT_CONFIG).collaborationGraphUrl
});
var $aa879c001d66f150$export$2e2bcd8739ae039 = $aa879c001d66f150$var$_default_1;









const $32fcad8519cf6cbf$export$28456d095a642fd = 'internal.browse-users-allowed';
const $32fcad8519cf6cbf$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $32fcad8519cf6cbf$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $32fcad8519cf6cbf$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $32fcad8519cf6cbf$export$c8a50bf6c196fc10 extends (0, $c7e7d5b8af685409$export$42f6d6baced34b2d) {
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $32fcad8519cf6cbf$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $32fcad8519cf6cbf$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $32fcad8519cf6cbf$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $32fcad8519cf6cbf$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
}
const $32fcad8519cf6cbf$export$ead519165de472de = new $32fcad8519cf6cbf$export$c8a50bf6c196fc10((0, $1ystj.DEFAULT_CONFIG).stargateRoot, {
    logException: $hAdDP.logException
});








function $798ccbbb6d8f5ae8$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}


const $44e63dc7aae1fba2$export$c5a8a79f1b20a4a9 = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ],
    [
        'aboutMe',
        'about_me'
    ],
    [
        'pronouns',
        'pronouns'
    ]
]);


const $3ba099b3a23d7b36$export$4b8b1bffa891fe4b = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);


const $967b9f1963c59823$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ((0, $3ba099b3a23d7b36$export$4b8b1bffa891fe4b).has(key)) output[(0, $3ba099b3a23d7b36$export$4b8b1bffa891fe4b).get(key)] = input[key];
        if ((0, $44e63dc7aae1fba2$export$c5a8a79f1b20a4a9).has(key)) output.extended_profile[(0, $44e63dc7aae1fba2$export$c5a8a79f1b20a4a9).get(key)] = input[key];
    });
    return output;
};


var $6bcae789298ff296$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    // aka `Public name`
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $6bcae789298ff296$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $6bcae789298ff296$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};


const $48c78138e5280970$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && (0, $6bcae789298ff296$export$2ff7b92b9e1bb4d2)[field]) return data[(0, $6bcae789298ff296$export$2ff7b92b9e1bb4d2)[field]];
    const mappedFieldKey = field in (0, $6bcae789298ff296$export$78158d2c2c6998d9) ? (0, $6bcae789298ff296$export$78158d2c2c6998d9)[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $48c78138e5280970$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values((0, $6bcae789298ff296$export$ed12481c953b8653)).includes(key)) return key;
    return undefined;
};
const $48c78138e5280970$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $48c78138e5280970$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $48c78138e5280970$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $48c78138e5280970$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys((0, $6bcae789298ff296$export$78158d2c2c6998d9)).map((field)=>$48c78138e5280970$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });


const $7b9c9cf1ff7f12e1$var$defaultConfig = {
    serviceUrl: `${(0, $1ystj.DEFAULT_CONFIG).stargateRoot}/users`
};
class $7b9c9cf1ff7f12e1$export$f9c003efee04f318 extends (0, $8cYxi.RestClient) {
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $48c78138e5280970$export$d7725d3d27b80a68)(resp);
        });
    }
    /**
   * @deprecated
   * User fetchUserAvatarInfo instead
   */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $967b9f1963c59823$export$7b103107c889cb67)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $798ccbbb6d8f5ae8$export$80d19edb7b1ae293)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
    constructor(config = {}){
        super({
            ...$7b9c9cf1ff7f12e1$var$defaultConfig,
            ...config
        });
    }
}


const $3fc3858320686094$var$_default_1 = new (0, $7b9c9cf1ff7f12e1$export$f9c003efee04f318)();
var $3fc3858320686094$export$2e2bcd8739ae039 = $3fc3858320686094$var$_default_1;











/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $ae328f04650ba706$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $ae328f04650ba706$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $ae328f04650ba706$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($ae328f04650ba706$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($ae328f04650ba706$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($ae328f04650ba706$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($ae328f04650ba706$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $ae328f04650ba706$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $ae328f04650ba706$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $ae328f04650ba706$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($ae328f04650ba706$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($ae328f04650ba706$var$toRecommendation)
        }
    };
};



const $d9a7825a1e15abf6$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $d9a7825a1e15abf6$export$3209eb31343f39d extends (0, $8cYxi.RestClient) {
    async getProductRecommendationsInner(supportedProducts = $d9a7825a1e15abf6$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $d9a7825a1e15abf6$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${(0, $24dcfe57978b22de$export$dc10d250afea259)}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $d9a7825a1e15abf6$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $ae328f04650ba706$export$d9d1c981635dd213)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource((0, $24dcfe57978b22de$export$780422f4a13c60e), request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
}


const $24dcfe57978b22de$export$dc10d250afea259 = '/v1/product-recommendations';
const $24dcfe57978b22de$export$780422f4a13c60e = '/v1/access-requests/bulk/request';
// eslint-disable-next-line import/no-anonymous-default-export
const $24dcfe57978b22de$var$_default_1 = new (0, $d9a7825a1e15abf6$export$3209eb31343f39d)((0, $1ystj.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $hAdDP.logException
});
var $24dcfe57978b22de$export$2e2bcd8739ae039 = $24dcfe57978b22de$var$_default_1;








const $12f215e5cee7ee00$var$v3UrlPath = `/v3/teams`;
const $12f215e5cee7ee00$var$v4UrlPath = `/v4/teams`;
class $12f215e5cee7ee00$export$68a6a391e3cf23be extends (0, $8cYxi.RestClient) {
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId, cloudId) {
        const siteId = this.getCloudId(cloudId);
        const teamResponse = await this.getResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const enablePagination = allTeamsQuery.enablePagination ?? true;
            const { entities: entities, cursor: cursor } = await this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                sortBy: allTeamsQuery.useDefaultSort ? null : allTeamsQuery.sortBy && allTeamsQuery.sortBy.length > 0 ? allTeamsQuery.sortBy : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams,
                teamTypeIdsFilter: allTeamsQuery.teamTypeIdsFilter,
                enablePagination: enablePagination,
                ...enablePagination && allTeamsQuery.cursor ? {
                    cursor: allTeamsQuery.cursor
                } : {}
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
   * @private
   * @deprecated use publicApiClient.addUsersToTeam instead
   */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$12f215e5cee7ee00$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$12f215e5cee7ee00$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
   * @private
   * @deprecated in V4, as no invitation status for team membership anymore.
   */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$12f215e5cee7ee00$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
   * @private
   * @deprecated in V4, as no invitation status for team membership anymore.
   */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$12f215e5cee7ee00$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async addAgentsToTeam(teamId, agents) {
        if (!agents || agents.length === 0) {
            const missingAgentsError = new Error('Missing agents to add');
            this.logException(missingAgentsError, 'addAgentToTeam');
            throw missingAgentsError;
        }
        try {
            const url = `${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents`;
            return this.postResource(url, {
                agents: agents
            });
        } catch (e) {
            this.logException(e, 'addAgentToTeam');
            throw e;
        }
    }
    async removeAgentTeamAssociation(teamId, agentId) {
        try {
            const url = `${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents/${agentId}`;
            return this.deleteResource(url);
        } catch (e) {
            this.logException(e, 'removeAgentTeamAssociation');
            throw e;
        }
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
   * @private
   * @deprecated use publicApiClient.removeTeamMemberships instead
   */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$12f215e5cee7ee00$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
   * @private
   * @deprecated INVITED status has been deprecated
   */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$12f215e5cee7ee00$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    async archiveTeam(teamId) {
        const siteId = this.getCloudId();
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/archive?siteId=${siteId}`);
    }
    async unArchiveTeam(teamId) {
        const siteId = this.getCloudId();
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/unarchive?siteId=${siteId}`);
    }
    async unlinkTeamFromGroup(teamId, membershipSettings) {
        return this.patchResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, {
            membershipSettings: membershipSettings
        });
    }
    /**
   * @private
   * @deprecated should be other means to solve this issue
   */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN', typeId) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$12f215e5cee7ee00$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ],
            typeId: typeId
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$12f215e5cee7ee00$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$12f215e5cee7ee00$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
   * Shoud only be used within Teams (P&T) packages
   */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$12f215e5cee7ee00$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId, siteId) {
        const finalSiteId = siteId || this.getCloudId();
        if (!finalSiteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${teamId}/profile?siteId=${finalSiteId}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$12f215e5cee7ee00$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async createTeamContainers(payload) {
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/containers`, {
            ...payload
        });
    }
    async getTeamEnabledSites(teamId) {
        const teamEnabledSites = await this.getResourceCached(`${$12f215e5cee7ee00$var$v4UrlPath}/migrations/scope/${teamId}`);
        return teamEnabledSites;
    }
    async assignTeamsToSites(migrations) {
        const assignTeamsToSitesResponse = await this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/migrations/scope`, {
            originOrgId: this.getContext().orgId,
            migrations: migrations
        });
        return assignTeamsToSitesResponse;
    }
    async getTeamsToBeClonedToJsmSites(teamsToSiteScope) {
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/migrations/scope/review`, {
            orgId: this.getContext().orgId,
            teamsToSiteScope: teamsToSiteScope
        });
    }
    async setTeamSiteAssignmentPermission(orgId, alignmentPermission) {
        return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/migrations/scope/permissions`, {
            orgId: orgId,
            alignmentPermission: alignmentPermission
        });
    }
    async getAssignedTeams(orgId, count, cursor, displayNameContains) {
        const assignedTeamsResponse = await this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/migrations/scope/aligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            displayNameContains: displayNameContains
        });
        return assignedTeamsResponse;
    }
    async getUnassignedTeams(orgId, count, cursor, query) {
        const unassignedTeamsResponse = await this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/migrations/scope/unaligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            query: query
        });
        return unassignedTeamsResponse;
    }
    async getTeamSiteAssignmentOrgDetails() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getTeamSiteAssignmentOrgDetails');
            throw err;
        }
        return this.getResource(`${$12f215e5cee7ee00$var$v4UrlPath}/migrations/scope/details/${orgId}`);
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified,
            ...teamResponse.externalReference && {
                externalReference: {
                    id: teamResponse.externalReference.id,
                    source: teamResponse.externalReference.source
                }
            }
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            // Team Search API does not return members
            members: [],
            // Team Search API does not return members
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
    checkOrgFullAlignmentStatus(orgId) {
        try {
            return this.getResource(`${$12f215e5cee7ee00$var$v4UrlPath}/migrations/scope/${orgId}/fully-aligned`);
        } catch (e) {
            this.logException(e, 'checkOrgFullAlignmentStatus');
            throw e;
        }
    }
    async getTeamStatesInBulk(orgId, teamIds) {
        try {
            return this.postResource(`${$12f215e5cee7ee00$var$v4UrlPath}/adminhub/states/bulk`, {
                orgId: orgId,
                teamIds: teamIds
            });
        } catch (e) {
            this.logException(e, 'getTeamStatesInBulk');
            throw e;
        }
    }
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = void 0;
        this.serviceUrlRoot = serviceUrl;
    }
}
const $12f215e5cee7ee00$export$95c697fe95d86a77 = new $12f215e5cee7ee00$export$68a6a391e3cf23be((0, $1ystj.DEFAULT_CONFIG).stargateRoot);












const $72d646e51a829065$var$defaultConfig = {
    serviceUrl: `${(0, $1ystj.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
function $72d646e51a829065$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[0, $6db41c63818a6383$export$4a9268c1fce7a09b] != null) for (const value of json[0, $6db41c63818a6383$export$4a9268c1fce7a09b])constraints = constraints.concat({
        field: value[0, $6db41c63818a6383$export$a874e1fd1f751271],
        reason: $72d646e51a829065$var$determineReason(value[0, $6db41c63818a6383$export$42dbd50dfa717b8f])
    });
    return constraints;
}
function $72d646e51a829065$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $keJGW.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
class $72d646e51a829065$export$1f387592ab3ca6d0 extends (0, $8cYxi.RestClient) {
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $72d646e51a829065$var$mapToMutabilityConstraints(resp);
        });
    }
    constructor(config = {}){
        super({
            ...$72d646e51a829065$var$defaultConfig,
            ...config
        });
    }
}


const $6db41c63818a6383$export$4a9268c1fce7a09b = 'not_editable';
const $6db41c63818a6383$export$a874e1fd1f751271 = 'field';
const $6db41c63818a6383$export$42dbd50dfa717b8f = 'reason';
// eslint-disable-next-line import/no-anonymous-default-export
const $6db41c63818a6383$var$_default_1 = new (0, $72d646e51a829065$export$1f387592ab3ca6d0)();
var $6db41c63818a6383$export$2e2bcd8739ae039 = $6db41c63818a6383$var$_default_1;








/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $d053be6d1c037b21$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});


const $0b7a65defeb54e00$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $0b7a65defeb54e00$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;
const $0b7a65defeb54e00$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $d053be6d1c037b21$export$132d457a8475f4c8).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $0b7a65defeb54e00$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $d053be6d1c037b21$export$132d457a8475f4c8).JIRA:
            return {
                linkUrl: url,
                iconUrl: $0b7a65defeb54e00$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};


const $ae96897c0db314e6$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $ae96897c0db314e6$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($ae96897c0db314e6$var$isIconItemSuccess).map((resp)=>resp.body.data).map((0, $0b7a65defeb54e00$export$c64ca1c808335e8b)).filter((linkIconData)=>linkIconData.iconUrl !== undefined);


const $f5f47413d32b0c0b$var$defaultConfig = {
    serviceUrl: `${(0, $1ystj.DEFAULT_CONFIG).stargateRoot}`
};
class $f5f47413d32b0c0b$export$a78b00aedb6cb3e9 extends (0, $8cYxi.RestClient) {
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $ae96897c0db314e6$export$39f4468adf4cb57c));
    }
    async getAriFromUrl(url) {
        return this.postResourceRaw(`/object-resolver/converter/toAri`, JSON.stringify({
            resourceUrl: url
        })).then((response)=>response?.data?.ari);
    }
    async getWebLinkTitle(webLinkUrl) {
        try {
            const response = await this.postResourceRaw('/object-resolver/resolve', JSON.stringify({
                resourceUrl: webLinkUrl
            }));
            if (response && 'data' in response) {
                if (response.data?.name) return response.data.name;
            }
            if (response && 'meta' in response && (response.meta?.visibility === 'restricted' || response.meta?.visibility === 'unauthorized')) {
                const auth = response.meta.auth?.[0];
                if (auth?.displayName) return auth.displayName;
            }
            return;
        } catch (error) {
            return;
        }
    }
    constructor(config = {}){
        super({
            ...$f5f47413d32b0c0b$var$defaultConfig,
            ...config
        });
    }
}


const $82963647fa06fd6f$var$_default_1 = new (0, $f5f47413d32b0c0b$export$a78b00aedb6cb3e9)();
var $82963647fa06fd6f$export$2e2bcd8739ae039 = $82963647fa06fd6f$var$_default_1;








class $37a00b715554c475$export$23820d8d740dd467 extends (0, $8cYxi.RestClient) {
    getIsSiteAdmin(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}


/**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
const $bf3fbd4eed903082$var$_default_1 = new (0, $37a00b715554c475$export$23820d8d740dd467)({
    serviceUrl: (0, $1ystj.DEFAULT_CONFIG).permsServiceUrl
});
var $bf3fbd4eed903082$export$2e2bcd8739ae039 = $bf3fbd4eed903082$var$_default_1;


/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 



var $dQN6V = parcelRequire("dQN6V");

// eslint-disable-next-line import/no-anonymous-default-export
const $636266163496b003$var$_default_1 = new (0, $dQN6V.PublicApiClient)((0, $1ystj.DEFAULT_CONFIG).publicApiRoot);
var $636266163496b003$export$2e2bcd8739ae039 = $636266163496b003$var$_default_1;








const $4f0ac305ec93b5ba$var$defaultConfig = {
    serviceUrl: `${(0, $1ystj.DEFAULT_CONFIG).stargateRoot}/user-tenure/v1`
};
class $4f0ac305ec93b5ba$export$e019a6241c871c27 extends (0, $8cYxi.RestClient) {
    async getUserTenure(userId) {
        const orgId = this.getOrgId();
        return this.getResource(`/${orgId}/${userId}`).then((response)=>({
                ...response,
                userHireDate: new Date(response.userHireDate)
            })).catch((_error)=>{
            throw new Error('Failed to fetch user tenure');
        });
    }
    constructor(config = {}){
        super({
            ...$4f0ac305ec93b5ba$var$defaultConfig,
            ...config
        });
    }
}


const $07d2890aeb1084cc$var$_default_1 = new (0, $4f0ac305ec93b5ba$export$e019a6241c871c27)();
var $07d2890aeb1084cc$export$2e2bcd8739ae039 = $07d2890aeb1084cc$var$_default_1;















const $567b9896f8579ba9$var$_default_1 = (0, $bPh6H.print)((0, $iLX84.default)`fragment ReportingLinesUserPII on UserPII{name picture accountStatus extendedProfile{jobTitle}}fragment ReportingLinesUserFragment on ReportingLinesUser{accountIdentifier identifierType numberOfDirectReports numberOfTotalReports pii{...ReportingLinesUserPII}}query ReportingLines($aaid:String){reportingLines(aaidOrHash:$aaid){lastModifiedDate user{...ReportingLinesUserFragment}managers{...ReportingLinesUserFragment}peers{...ReportingLinesUserFragment}reports{...ReportingLinesUserFragment}}}`);
var $567b9896f8579ba9$export$2e2bcd8739ae039 = $567b9896f8579ba9$var$_default_1;


const $a9de182f75d7b701$var$SERVICE_URL = `${(0, $1ystj.DEFAULT_CONFIG).stargateRoot}/watermelon/graphql`;
class $a9de182f75d7b701$export$59b34df773148edd extends (0, $c7e7d5b8af685409$export$42f6d6baced34b2d) {
    async getReportingLines(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $567b9896f8579ba9$export$2e2bcd8739ae039),
            variables: {
                aaid: userId
            }
        }, {
            operationName: 'ReportingLines'
        });
        return response;
    }
    constructor(config){
        super($a9de182f75d7b701$var$SERVICE_URL, config);
    }
}


const $6e1151330d6ac1ad$var$_default_1 = new (0, $a9de182f75d7b701$export$59b34df773148edd)({
    logException: $hAdDP.logException
});
var $6e1151330d6ac1ad$export$2e2bcd8739ae039 = $6e1151330d6ac1ad$var$_default_1;









const $982cb0f6e6839142$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;


const $cdd31a0828c0a065$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;








const $59189ace9889d039$export$2af9f827ad8bcf83 = (0, $bPh6H.print)((0, $iLX84.default)`mutation addTeamWatcher($teamId:String!$cloudId:String){addTeamWatcher(input:{teamId:$teamId cloudId:$cloudId}){isWatching __typename}}`);








const $96c1535bd24cfae9$export$5e59562b4f09e8ef = (0, $bPh6H.print)((0, $iLX84.default)`mutation createTagForCloudId($name:String!$cloudId:String!){createTagForCloudId(input:{name:$name cloudId:$cloudId}){tag{id uuid name}}}`);








const $e2f1329362abc301$export$a563da8c932d52b1 = (0, $bPh6H.print)((0, $iLX84.default)`mutation CreateHelpPointer($cloudId:String!$description:String$icon:IconInput$tagUuids:[UUID]$link:String!$name:String!$teamId:String!$type:HelpPointerType!){createHelpPointer(input:{cloudId:$cloudId description:$description icon:$icon tagUuids:$tagUuids link:$link name:$name teamId:$teamId type:$type}){helpPointer{id}}}`);








const $b60a525380542f4a$export$558c9434019572a1 = (0, $bPh6H.print)((0, $iLX84.default)`mutation DeleteHelpPointer($id:ID!){deleteHelpPointer(input:{id:$id}){success}}`);








const $edc20e2505e87648$export$95b572ae48a37250 = (0, $bPh6H.print)((0, $iLX84.default)`mutation UpdateHelpPointer($id:ID!$description:String$teamId:String$newTeamName:String$icon:IconInput$tagUuids:[UUID]$link:String$name:String$type:HelpPointerType){updateHelpPointer(input:{id:$id description:$description icon:$icon tagUuids:$tagUuids link:$link teamId:$teamId newTeamName:$newTeamName name:$name type:$type}){helpPointer{id}}}`);








const $cb34f193b8cc991c$export$fc4c702e715ad2a4 = (0, $bPh6H.print)((0, $iLX84.default)`mutation DeleteKudos($id:ID!){deleteKudos(input:{id:$id}){success kudos{id}}}`);








const $3aab4aa121ad561c$export$d1957676c49feb6a = (0, $bPh6H.print)((0, $iLX84.default)`mutation removeTeamWatcher($teamId:String!$cloudId:String){removeTeamWatcher(input:{teamId:$teamId cloudId:$cloudId}){isWatching __typename}}`);








const $f9ce2483b386d1f3$export$5deef0b43df462bc = (0, $bPh6H.print)((0, $iLX84.default)`query IsTeamWatcher($teamId:String!$cloudId:String!){isTeamWatcher:teamByTeamId(teamId:$teamId cloudId:$cloudId){watching}}`);








const $f514dca6c7bc8909$export$2c592b5c06672873 = (0, $bPh6H.print)((0, $iLX84.default)`query TagListByCloudId($q:String!$cloudId:String!$first:Int){tagSearchByCloudId(q:$q cloudId:$cloudId first:$first){edges{node{id uuid name projects{count}goals{count}helpLinks{count}}}}}`);


class $ff240069c1602e5f$export$de0359e19b851166 extends (0, $c7e7d5b8af685409$export$42f6d6baced34b2d) {
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $982cb0f6e6839142$export$ada1892306a6b676)(baseUrl, cloudId) : (0, $cdd31a0828c0a065$export$71356c4826ea823a)(baseUrl));
    }
    async isTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $f9ce2483b386d1f3$export$5deef0b43df462bc),
            variables: {
                teamId: teamId.replace('ari:cloud:identity::team/', ''),
                cloudId: cloudId || 'None'
            }
        }, {
            operationName: 'isTeamWatcher'
        });
        return response.isTeamWatcher;
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $59189ace9889d039$export$2af9f827ad8bcf83),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $3aab4aa121ad561c$export$d1957676c49feb6a),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $cb34f193b8cc991c$export$fc4c702e715ad2a4),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $f514dca6c7bc8909$export$2c592b5c06672873),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $96c1535bd24cfae9$export$5e59562b4f09e8ef),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $e2f1329362abc301$export$a563da8c932d52b1),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $edc20e2505e87648$export$95b572ae48a37250),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $b60a525380542f4a$export$558c9434019572a1),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
    constructor(baseUrl, config){
        super((0, $cdd31a0828c0a065$export$71356c4826ea823a)(baseUrl), config);
    }
}


const $c2049e4827310bf8$var$_default_1 = new (0, $ff240069c1602e5f$export$de0359e19b851166)((0, $1ystj.DEFAULT_CONFIG).stargateRoot, {
    logException: $hAdDP.logException
});
var $c2049e4827310bf8$export$2e2bcd8739ae039 = $c2049e4827310bf8$var$_default_1;








const $3d0c7e8f01515eb7$var$defaultConfig = {
    serviceUrl: `${(0, $1ystj.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $3d0c7e8f01515eb7$export$9509cbc6b0605446 extends (0, $8cYxi.RestClient) {
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    constructor(config = {}){
        super({
            ...$3d0c7e8f01515eb7$var$defaultConfig,
            ...config
        });
    }
}


const $4a6ed51f2be0c41f$var$_default_1 = new (0, $3d0c7e8f01515eb7$export$9509cbc6b0605446)();
var $4a6ed51f2be0c41f$export$2e2bcd8739ae039 = $4a6ed51f2be0c41f$var$_default_1;








const $0ef4baa521df3ac7$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $0ef4baa521df3ac7$export$3c27e20d1b94924 extends (0, $8cYxi.RestClient) {
    async getReadMediaToken(accountId) {
        return this.getResource($0ef4baa521df3ac7$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}


const $1bd281c9cbd320f1$var$_default_1 = new (0, $0ef4baa521df3ac7$export$3c27e20d1b94924)({
    serviceUrl: (0, $1ystj.DEFAULT_CONFIG).stargateRoot
});
var $1bd281c9cbd320f1$export$2e2bcd8739ae039 = $1bd281c9cbd320f1$var$_default_1;


class $e569cc7f83eec107$export$db59823f35bf78ce {
    async measurePerformance(name, fn) {
        const exp = (0, $4e3b9b5f05e99dc1$export$879344107b04120c).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
   * Sets the base URL to be used in the client requests
   * @param {string} baseUrl - The new base URL
   */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
   * Sets context including CloudId & OrgId to be used for all requests
   */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
        this._replinesClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
   * @private
   * @deprecated use setBaseUrl instead
   */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
   * Fetches Browse user settings
   */ async querySettings(cloudId, product) {
        if (cloudId) {
            const previousContext = this._legionClient.getContext();
            this.setContext({
                ...previousContext,
                cloudId: cloudId
            });
        }
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
   * This will return all of the teams-related permissions that your user has for the org and site in the client context.
   */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
   * Fetches feature flags from Directory
   * @deprecated As part of decommisioning pf-directoy
   */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
   * Get user information of members of a team, paginated
   * @param {string} teamId
   * @returns {Promise}
   */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
   * Get user information given an user id
   * @param {string} userId
   * @returns {Promise}
   */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
   * Get the agents associated with the team
   * @param {string} userId
   * @returns {Promise}
   */ async queryTeamHasAgents(teamId) {
        return this._aggClient.queryTeamHasAgents(teamId);
    }
    /**
   * Get containers associated with the team
   * @param {string} teamId
   * @returns {Promise<TeamContainers>}
   */ async getTeamContainers(teamId) {
        return this._aggClient.getTeamContainers(teamId);
    }
    /**
   * Unlink a container from a team
   * @param {string} teamId
   * @param {string} containerId
   * @returns {Promise}
   */ async unlinkTeamContainer(teamId, containerId) {
        return this._aggClient.unlinkTeamContainer(teamId, containerId);
    }
    /**
   * Get the number of teams connected to a container
   * @param {string} containerId
   * @returns {Promise<number>}
   */ async queryNumberOfTeamConnectedToContainer(containerId) {
        return this._aggClient.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
   * Get the number of teams connected to a container (Confluence space or Jira project)
   * @param {string} containerId
   * @returns {Promise<number>}
   */ async getNumberOfConnectedTeams(containerId) {
        return this.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
   * Get teams connected to a container
   * @param {string} containerId
   * @returns {Promise<TeamWithMemberships[]>}
   */ async queryTeamsConnectedToContainer(containerId) {
        return this._aggClient.queryTeamsConnectedToContainer(containerId);
    }
    /**
   * Get teams connected to a container (Confluence space or Jira project)
   * @param {string} containerId
   * @returns {Promise<TeamWithMemberships[]>}
   */ async getConnectedTeams(containerId) {
        return this.queryTeamsConnectedToContainer(containerId);
    }
    /**
   * Get user information of a member of a team
   * @param {string} userId
   * @returns {Promise<CloudUser>}
   */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
   *
   * @param teamId
   * @returns {Promise<TeamWithImageUrls>}
   */ async getTeamById(teamId, cloudId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId, cloudId));
    }
    /**
   * Search teams based on query
   */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
   * Update team details
   */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
   * @private
   * @deprecated use addUsersToTeam instead
   */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
   * Get the current user's team membership
   */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
   * Get a teams "Links"
   */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
   * Create a team link
   */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
   * Update a team link
   */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
   * Delete a team link
   */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
   * Reorder a team link
   */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
   * Get org's eligibility for managed teams
   */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
   * @deprecated Invitation status no longer exists
   * Accept a team invitation
   */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
   * @deprecated Invitation status no longer exists
   * Decline a team invitation
   */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
   * Add current user to a team
   */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
   * Add agent to a team
   */ async addAgentsToTeam(...args) {
        return this.measurePerformance('addAgentToTeam', ()=>this._legionClient.addAgentsToTeam(...args));
    }
    async removeAgentTeamAssociation(...args) {
        return this.measurePerformance('removeAgentTeamAssociation', ()=>this._legionClient.removeAgentTeamAssociation(...args));
    }
    /**
   * Cancel a join request to a private team
   */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
   * Accept a join request to a private team
   */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
   * Decline a join request to a private team
   */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
   * @deprecated use removeTeamMemberships instead
   */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
   * @deprecated INVITED status has been deprecated
   */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
   * Delete a team
   */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
   * Archive a team
   */ async archiveTeam(teamId) {
        return this.measurePerformance('archiveTeam', ()=>this._legionClient.archiveTeam(teamId));
    }
    /**
   * Unarchive a team
   */ async unarchiveTeam(teamId) {
        return this.measurePerformance('unarchiveTeam', ()=>this._legionClient.unArchiveTeam(teamId));
    }
    /**
   * Unlink a team from group
   */ async unlinkTeamFromGroup(teamId) {
        return this.measurePerformance('unlinkTeamFromGroup', ()=>this._legionClient.unlinkTeamFromGroup(teamId, 'MEMBER_INVITE'));
    }
    /**
   * @private
   * @deprecated should be other means to solve this issue
   */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
   * Create a team
   */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
   * Create containers for a team
   */ async createTeamContainers(...args) {
        return this.measurePerformance('createTeamContainers', ()=>this._legionClient.createTeamContainers(...args));
    }
    /**
   * Create a external team
   * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
   * @param {ExternalReference} externalReference
   */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
   * Get linked teams for a groups in bulk
   * @param {string} groupIds - The group ids to fetch linked teams for
   */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
   * Get Org scope
   */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
   * Restore soft-deleted team and sync to group
   */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
   * Get the difference between a team and a group
   * @param teamId
   * @param {ExternalReference} externalReference
   * @returns {Promise<TeamAndGroupDifference>}
   */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
   * Link an existing team to a group
   * @param teamId
   * @param {ExternalReference} externalReference
   */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
   *
   * @param teamId
   * @returns {Promise<LinkedTeamsProfileDetails>}
   */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
   *
   * @param teamId
   * @returns {Promise<SoftDeletedTeam>}
   */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
   * Shoud only be used within Teams (P&T) packages
   * @param userId
   * @returns {Promise<SoftDeletedTeam>}
   */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
   * Get user profile with mutability constraints
   */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
   * Get enabled sites for a team
   */ async getTeamEnabledSites(...args) {
        return this.measurePerformance('getTeamEnabledSites', ()=>this._legionClient.getTeamEnabledSites(...args));
    }
    /**
   * Assign teams to sites
   * @param migrations
   * @returns {Promise<AssignTeamsToSitesResponse>}
   */ async assignTeamsToSites(...args) {
        return this.measurePerformance('assignTeamsToSites', ()=>this._legionClient.assignTeamsToSites(...args));
    }
    /**
   * Get assigned teams
   * @param orgId
   * @param cursor
   * @param displayNameContains
   * @param count - number of teams to return
   */ async getAssignedTeams(...args) {
        return this.measurePerformance('getAssignedTeams', ()=>this._legionClient.getAssignedTeams(...args));
    }
    /**
   * Get unassigned teams
   * @param orgId
   * @param count - number of teams to return
   * @param cursor - cursor to the next page of results
   * @param query - query to filter teams by
   */ async getUnassignedTeams(...args) {
        return this.measurePerformance('getUnassignedTeams', ()=>this._legionClient.getUnassignedTeams(...args));
    }
    /**
   * Set team site assignment permission
   * @param orgId
   * @param alignmentPermission - 'ALL_USERS' | 'ORG_ADMIN'
   */ async setTeamSiteAssignmentPermission(...args) {
        return this.measurePerformance('setTeamSiteAssignmentPermission', ()=>this._legionClient.setTeamSiteAssignmentPermission(...args));
    }
    /**
   * Get team site assignment org details
   */ async getTeamSiteAssignmentOrgDetails(...args) {
        return this.measurePerformance('getTeamSiteAssignmentOrgDetails', ()=>this._legionClient.getTeamSiteAssignmentOrgDetails(...args));
    }
    /**
   * Get teams to be cloned to JSM sites
   */ async getTeamsToBeClonedToJsmSites(...args) {
        return this.measurePerformance('getTeamsToBeClonedToJsmSites', ()=>this._legionClient.getTeamsToBeClonedToJsmSites(...args));
    }
    /**
   * Is the current user a site admin
   */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
   * Add users to a team
   */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
   * Remove users from a team
   */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
   * Restore a deleted team
   */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
   * Get token to upload media for a team
   */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
   * Get token to read media for a user
   */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
   * Get token to upload media for a user
   */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
   * Update header image for a user
   */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
   * Fetch user containers from collboration graph
   */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
   * Fetch recommended users from collaboration graph
   */ async getRecommendedUsers(...args) {
        return this.measurePerformance('getRecommendedUsers', ()=>this._collaborationGraphClient.getRecommendedUsers(...args));
    }
    /**
   * Fetch mutatability of external managed user fields
   */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
   * Fetch user avatar uploaded status
   */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
   * Delete user avatar
   */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
   * Fetch Team link icons
   */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
   * Fetch ARI from URL
   */ async getAriFromUrl(...args) {
        return this.measurePerformance('getAriFromUrl', ()=>this._objectResolverClient.getAriFromUrl(...args));
    }
    /**
   * Fetch web link title
   */ async getWebLinkTitle(...args) {
        return this.measurePerformance('getWebLinkTitle', ()=>this._objectResolverClient.getWebLinkTitle(...args));
    }
    /**
   * Fetch team in slack details
   */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
   * Delete team in slack
   */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
   * Update team in slack
   */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
   * Update user details
   */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async isTeamWatcher(...args) {
        return this._teamCentralClient.isTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
    async getUserTenure(...args) {
        return this.measurePerformance('getUserTenure', ()=>this._replinesClient.getUserTenure(...args));
    }
    async checkOrgFullAlignmentStatus(...args) {
        return this._legionClient.checkOrgFullAlignmentStatus(...args);
    }
    async getTeamStatesInBulk(...args) {
        return this._legionClient.getTeamStatesInBulk(...args);
    }
    async getReportingLines(...args) {
        return this.measurePerformance('getReportingLines', ()=>this._reportingLinesClient.getReportingLines(...args));
    }
    constructor(/**
   * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
   */ context){
        this._aggClient = (0, $81bcc742addbac25$export$464c991dbf0b2393);
        this._directoryClient = (0, $32fcad8519cf6cbf$export$ead519165de472de);
        this._legionClient = (0, $12f215e5cee7ee00$export$95c697fe95d86a77);
        this._mutabilityClient = (0, $6db41c63818a6383$export$2e2bcd8739ae039);
        this._permsClient = (0, $bf3fbd4eed903082$export$2e2bcd8739ae039);
        this._publicApiClient = (0, $636266163496b003$export$2e2bcd8739ae039);
        this._invitationsClient = (0, $24dcfe57978b22de$export$2e2bcd8739ae039);
        this._userPreferencesClient = (0, $1bd281c9cbd320f1$export$2e2bcd8739ae039);
        this._objectResolverClient = (0, $82963647fa06fd6f$export$2e2bcd8739ae039);
        this._teamsInSlackClient = (0, $4a6ed51f2be0c41f$export$2e2bcd8739ae039);
        this._collaborationGraphClient = (0, $aa879c001d66f150$export$2e2bcd8739ae039);
        this._identityClient = (0, $3fc3858320686094$export$2e2bcd8739ae039);
        this._teamCentralClient = (0, $c2049e4827310bf8$export$2e2bcd8739ae039);
        this._replinesClient = (0, $07d2890aeb1084cc$export$2e2bcd8739ae039);
        this._reportingLinesClient = (0, $6e1151330d6ac1ad$export$2e2bcd8739ae039);
        if (context) this.setContext(context);
    }
}
const $e569cc7f83eec107$export$5ed932c3646b89c6 = new $e569cc7f83eec107$export$db59823f35bf78ce();
module.exports["teamsClient"] = $e569cc7f83eec107$export$5ed932c3646b89c6;

});

parcelRegister("9CzW0", function(module, exports) {

var $cNAch = parcelRequire("cNAch");

/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 








var $47521a7182094206$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $47521a7182094206$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
var $47521a7182094206$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});


function $6b29b75dca2a473d$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}



function $41fe19d625b1a62e$export$cde1786a482f9a1c(error) {
    return (0, $6b29b75dca2a473d$export$9677d7c364ada66c)((0, $47521a7182094206$export$f66f92b8741acd5b).UNAUTHORIZED, error) || (0, $6b29b75dca2a473d$export$9677d7c364ada66c)((0, $47521a7182094206$export$f66f92b8741acd5b).FORBIDDEN, error);
}



function $629368fcb2c5ade8$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}



var $1epkm = parcelRequire("1epkm");

const $7163dbdf042dd3f1$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $1epkm.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $1epkm.HttpError) ? error.status : undefined
        }
    });


const $d587f5dc1be8cd09$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $d587f5dc1be8cd09$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $d587f5dc1be8cd09$var$ignoredErrors.includes(errorName);
};


class $05fadd432f420b0a$export$9a18529d1e90e81a extends (0, $cNAch.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $7163dbdf042dd3f1$export$7286a0fb7b5aab6b)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $41fe19d625b1a62e$export$cde1786a482f9a1c)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $6b29b75dca2a473d$export$9677d7c364ada66c)((0, $47521a7182094206$export$f66f92b8741acd5b).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $d587f5dc1be8cd09$export$a8da197a8bcc7e95)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $629368fcb2c5ade8$export$476aa014e2fd89d5)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $7163dbdf042dd3f1$export$7286a0fb7b5aab6b)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}
module.exports["TeamsUFOExperience"] = $05fadd432f420b0a$export$9a18529d1e90e81a;

});

parcelRegister("1epkm", function(module, exports) {

var $1iVGe = parcelRequire("1iVGe");

class $9cb42f3e190d181b$export$65bd6083489bd8bb extends (0, $1iVGe.CommonError) {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        this.status = void 0;
        this.traceId = void 0;
        this.path = void 0;
        Object.setPrototypeOf(this, $9cb42f3e190d181b$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
module.exports["HttpError"] = $9cb42f3e190d181b$export$65bd6083489bd8bb;

});

parcelRegister("beNe1", function(module, exports) {

var $lcNLp = parcelRequire("lcNLp");


var $lf2Px = parcelRequire("lf2Px");

const $34c950176c172650$export$2bcc6e4924859c6f = (teamId)=>{
    return (0, $lf2Px.isTeamARI)(teamId) ? teamId : `${0, $lcNLp.TEAM_ARI_PREFIX}${teamId}`;
};
module.exports["toTeamARI"] = $34c950176c172650$export$2bcc6e4924859c6f;

});

parcelRegister("lcNLp", function(module, exports) {
const $79232d4976775160$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $79232d4976775160$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';
module.exports["USER_ARI_PREFIX"] = $79232d4976775160$export$470b0d72e4fdc43a;
module.exports["TEAM_ARI_PREFIX"] = $79232d4976775160$export$cfedc369802e0c68;

});

parcelRegister("lf2Px", function(module, exports) {

var $lcNLp = parcelRequire("lcNLp");

const $d1e6f35965510f34$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $lcNLp.TEAM_ARI_PREFIX));
module.exports["isTeamARI"] = $d1e6f35965510f34$export$7b81d5dfd83c8166;

});

parcelRegister("1ystj", function(module, exports) {
const $df7eebf263617712$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};
module.exports["DEFAULT_CONFIG"] = $df7eebf263617712$export$c2f8e0cc249a8d8f;

});

parcelRegister("hAdDP", function(module, exports) {
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $hDEIQ = parcelRequire("hDEIQ");


var $hcXxI = parcelRequire("hcXxI");

async function $3b8014791b441d7c$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $hcXxI.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            (0, $hDEIQ.decorateScope)(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
module.exports["logException"] = $3b8014791b441d7c$export$f86b2a1a2ce291b3;

});

parcelRegister("hDEIQ", function(module, exports) {
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript
function $1b7a825fdf438b1b$export$ae1d54724028f0c8(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
module.exports["decorateScope"] = $1b7a825fdf438b1b$export$ae1d54724028f0c8;

});

parcelRegister("hcXxI", function(module, exports) {

var $kiT72 = parcelRequire("kiT72");


var $9i8b3 = parcelRequire("9i8b3");

const $e717597cba9e523c$export$f553e8b08ef59d31 = async ()=>{
    if (!(0, $kiT72.sentryClientRef).current) await (0, $9i8b3.setupSentryClient)({});
    return (0, $kiT72.sentryClientRef).current;
};
module.exports["getSentryClient"] = $e717597cba9e523c$export$f553e8b08ef59d31;

});

parcelRegister("kiT72", function(module, exports) {
const $7ace4243e193c1cb$export$1b9e526db560a003 = {
    current: undefined
};
module.exports["sentryClientRef"] = $7ace4243e193c1cb$export$1b9e526db560a003;

});

parcelRegister("9i8b3", function(module, exports) {

var $jH9cM = parcelRequire("jH9cM");

const $dd30e0aab051e19f$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $dd30e0aab051e19f$export$68c35ed3898e185a = '5988845';
const $dd30e0aab051e19f$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $dd30e0aab051e19f$export$97db6664a1e55fa6 = '47';
const $dd30e0aab051e19f$var$SENTRY_COMMERCIAL_DSN = `https://${$dd30e0aab051e19f$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$dd30e0aab051e19f$export$68c35ed3898e185a}`;
const $dd30e0aab051e19f$var$SENTRY_FEDRAMP_DSN = `https://${$dd30e0aab051e19f$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$dd30e0aab051e19f$export$97db6664a1e55fa6}`;
const $dd30e0aab051e19f$export$6faa4a850bc4d0ce = (0, $jH9cM.isFedRamp)() ? $dd30e0aab051e19f$var$SENTRY_FEDRAMP_DSN : $dd30e0aab051e19f$var$SENTRY_COMMERCIAL_DSN;



const $1417777ae7545f8b$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $dd30e0aab051e19f$export$6faa4a850bc4d0ce),
    attachStacktrace: true
};
function $1417777ae7545f8b$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$1417777ae7545f8b$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}



var $kiT72 = parcelRequire("kiT72");




const $8b59924a1f8c8031$export$7d446c6f4e54de82 = (client)=>{
    (0, $kiT72.sentryClientRef).current = client;
};


const $8441465c279d97fa$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $8441465c279d97fa$export$357606956af25316(client, options) {
    if ((0, $kiT72.sentryClientRef).current) return;
    if (!client) return;
    (0, $8b59924a1f8c8031$export$7d446c6f4e54de82)(client);
    const sentryConfig = (0, $1417777ae7545f8b$export$5580e6304e95c792)(options);
    (0, $kiT72.sentryClientRef).current.init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $8441465c279d97fa$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}



async function $cd3d62f921b384c1$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("55apF"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
        return undefined;
    }
}
function $cd3d62f921b384c1$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}
async function $cd3d62f921b384c1$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $cd3d62f921b384c1$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $8441465c279d97fa$export$357606956af25316)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $cd3d62f921b384c1$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $dd30e0aab051e19f$export$6faa4a850bc4d0ce),
        attachStacktrace: true
    });
}
module.exports["setupSentryClient"] = $cd3d62f921b384c1$export$d8bd0edf6c978788;

});

parcelRegister("55apF", function(module, exports) {

let $3b357f295bbe6b1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b357f295bbe6b1c$var$load("kT6dz"),
    $3b357f295bbe6b1c$var$load("aAWLw")
]).then(()=>parcelRequire('eieXD'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("aVnuX", function(module, exports) {

var $asQBE = parcelRequire("asQBE");


var $38Dpg = parcelRequire("38Dpg");

const $64893fa9ea97f028$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
const $64893fa9ea97f028$export$b4c0bf5325504bf3 = (0, $38Dpg.withExponentialBackoff)((url, init)=>fetch(url, init), {
    initial: $64893fa9ea97f028$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $64893fa9ea97f028$export$8f4286bf21155381.JITTER,
    max: $64893fa9ea97f028$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>(0, $asQBE.is5xx)(response.status)
});
module.exports["EXPONENTIAL_BACKOFF_RETRY_POLICY"] = $64893fa9ea97f028$export$8f4286bf21155381;
module.exports["fetchWithExponentialBackoff"] = $64893fa9ea97f028$export$b4c0bf5325504bf3;

});

parcelRegister("948ml", function(module, exports) {
var $a7f420bcfceb4798$exports = {};

var $2Ryc1 = parcelRequire("2Ryc1");

/** Error message constants. */ var $a7f420bcfceb4798$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $a7f420bcfceb4798$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($a7f420bcfceb4798$var$FUNC_ERROR_TEXT);
    n = $2Ryc1(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
$a7f420bcfceb4798$exports = $a7f420bcfceb4798$var$before;


/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $699af8c278cd7982$var$once(func) {
    return $a7f420bcfceb4798$exports(2, func);
}
module.exports = $699af8c278cd7982$var$once;

});

parcelRegister("dQN6V", function(module, exports) {

var $1epkm = parcelRequire("1epkm");


var $k8GV7 = parcelRequire("k8GV7");


var $8cYxi = parcelRequire("8cYxi");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2ef1fbcae44a1954$export$37eb2c2284868e17 = '/teams/v1';


const $ecaf867867c88eef$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $ecaf867867c88eef$export$38575d07403d67c extends (0, $8cYxi.RestClient) {
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${(0, $2ef1fbcae44a1954$export$37eb2c2284868e17)}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $1epkm.HttpError) && $ecaf867867c88eef$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $k8GV7.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${(0, $2ef1fbcae44a1954$export$37eb2c2284868e17)}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${(0, $2ef1fbcae44a1954$export$37eb2c2284868e17)}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${(0, $2ef1fbcae44a1954$export$37eb2c2284868e17)}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${(0, $2ef1fbcae44a1954$export$37eb2c2284868e17)}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
}
module.exports["PublicApiClient"] = $ecaf867867c88eef$export$38575d07403d67c;

});

parcelRegister("keJGW", function(module, exports) {

var $1iVGe = parcelRequire("1iVGe");

class $4f5986cf794268d4$export$c73ca302efeda3b4 extends (0, $1iVGe.CommonError) {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $4f5986cf794268d4$export$c73ca302efeda3b4.prototype);
    }
}
module.exports["DefaultError"] = $4f5986cf794268d4$export$c73ca302efeda3b4;

});

parcelRegister("2CkPM", function(module, exports) {

var $1iVGe = parcelRequire("1iVGe");

class $b8fffde8e2c56ff6$export$d87f401f8106d7a2 extends (0, $1iVGe.CommonError) {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $b8fffde8e2c56ff6$export$d87f401f8106d7a2.prototype);
    }
}
module.exports["SLOIgnoreError"] = $b8fffde8e2c56ff6$export$d87f401f8106d7a2;

});

parcelRegister("DtqR5", function(module, exports) {

var $1iVGe = parcelRequire("1iVGe");

var $cf10f57e3a2f42b4$var$_GraphQLError;
class $cf10f57e3a2f42b4$export$92d6ed0888e7cb7f extends (0, $1iVGe.CommonError) {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        this.fields = void 0;
        // tslint:disable-line no-any
        this.category = void 0;
        Object.setPrototypeOf(this, $cf10f57e3a2f42b4$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
}
$cf10f57e3a2f42b4$var$_GraphQLError = $cf10f57e3a2f42b4$export$92d6ed0888e7cb7f;
$cf10f57e3a2f42b4$export$92d6ed0888e7cb7f.from = (rawErrors)=>{
    const firstError = rawErrors[0];
    const errorData = {
        category: firstError.category,
        message: firstError.message
    };
    if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
        obj[item.field] = item.message;
        return obj;
    }, {});
    return new $cf10f57e3a2f42b4$var$_GraphQLError(errorData);
};
module.exports["GraphQLError"] = $cf10f57e3a2f42b4$export$92d6ed0888e7cb7f;

});

parcelRegister("1iVGe", function(module, exports) {
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $30541afdca2ebb21$export$367e5905f68890c5 extends Error {
    constructor(message){
        super(message);
        this.message = void 0;
        this.name = void 0;
        this.stack = void 0;
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
module.exports["CommonError"] = $30541afdca2ebb21$export$367e5905f68890c5;

});

parcelRegister("asQBE", function(module, exports) {
/**
 * Checks whether a status code is a 5xx HTTP code.
 * @param {number} status HTTP status code
 */ function $514b5cb4cc7b3b77$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
module.exports["is5xx"] = $514b5cb4cc7b3b77$export$55b2fbd5d4a32495;

});

parcelRegister("38Dpg", function(module, exports) {
// tslint:disable-next-line no-any
// tslint:disable-next-line no-any
const $b1963f4e1b7aef8e$var$defaultRetryIfCallback = (a)=>!a;
const $b1963f4e1b7aef8e$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $b1963f4e1b7aef8e$var$defaultRetryIfCallback
};
function $b1963f4e1b7aef8e$export$20eaa22f2295996f(toTry, hofOptions = $b1963f4e1b7aef8e$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
   * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
   * The functioned-to-be-retried is called on each recursion.
   */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
module.exports["withExponentialBackoff"] = $b1963f4e1b7aef8e$export$20eaa22f2295996f;

});

parcelRegister("k8GV7", function(module, exports) {

var $1epkm = parcelRequire("1epkm");

class $e1e1d9a7d9a532d0$export$826a3d65b8435adf extends (0, $1epkm.HttpError) {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $e1e1d9a7d9a532d0$export$826a3d65b8435adf.prototype);
    }
}
module.exports["SLOIgnoreHttpError"] = $e1e1d9a7d9a532d0$export$826a3d65b8435adf;

});

parcelRegister("8cYxi", function(module, exports) {

var $1epkm = parcelRequire("1epkm");


var $2CkPM = parcelRequire("2CkPM");


var $aVnuX = parcelRequire("aVnuX");


var $gvPaz = parcelRequire("gvPaz");


var $bsEAi = parcelRequire("bsEAi");


var $ckWjy = parcelRequire("ckWjy");


var $HjYCN = parcelRequire("HjYCN");


var $knAnv = parcelRequire("knAnv");


var $cJ8tU = parcelRequire("cJ8tU");

const $ca5b824121d87362$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
class $ca5b824121d87362$export$ea8b5b3aea9558ce extends (0, $bsEAi.BaseClient) {
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
       * PATCH must be uppercase as per fetch spec only
       * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
       * are normalised to uppercase.
       *
       * https://github.com/github/fetch/issues/37
       * https://fetch.spec.whatwg.org/#methods
       */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$ca5b824121d87362$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $aVnuX.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $gvPaz.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $2CkPM.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $ckWjy.parseErrorMessage)(response);
                const httpError = new (0, $1epkm.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $cJ8tU.stripUUIDFromPath)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
        return additionalFetchOptions.ignoreResponse ? null : (0, $HjYCN.parseResponse)(response);
    }
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config);
        this.serviceUrl = void 0;
        /**
     * This function is necessary for if `statusCodeHandler` prescribes a login
     * redirect upon a 401 response.
     * While the default redirect behaviour may be overriden, this function has
     * been kept separate to ensure it cannot be overriden, lest a host
     * application supply embeddable-directory with a custom handler that suffers
     * the infinite redirect bug.
     */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) (0, $knAnv.redirectCount).increment();
            } else (0, $knAnv.redirectCount).clear();
        };
        this.serviceUrl = serviceUrl;
    }
}
module.exports["RestClient"] = $ca5b824121d87362$export$ea8b5b3aea9558ce;

});

parcelRegister("gvPaz", function(module, exports) {
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $1e3efc41927b14e3$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $1e3efc41927b14e3$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $1e3efc41927b14e3$export$8c005e458e12d501.handlers = handlers;
    }
};
function $1e3efc41927b14e3$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $1e3efc41927b14e3$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}
module.exports["handleResponse"] = $1e3efc41927b14e3$export$c113a67a6762ad2e;

});

parcelRegister("bsEAi", function(module, exports) {

var $hAdDP = parcelRequire("hAdDP");

class $e3fd5c8c67260586$export$4f22f74eddb7716a {
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || ''
        };
    }
    getContext() {
        return this.context;
    }
    /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
    constructor(config){
        this.config = void 0;
        this.context = void 0;
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $hAdDP.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: ''
        };
    }
}
module.exports["BaseClient"] = $e3fd5c8c67260586$export$4f22f74eddb7716a;

});

parcelRegister("ckWjy", function(module, exports) {
async function $2de6c5bcc63b8f98$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}
module.exports["parseErrorMessage"] = $2de6c5bcc63b8f98$export$91c32f1b22d29b2d;

});

parcelRegister("HjYCN", function(module, exports) {
function $6ceae2f28aadafe4$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}
module.exports["parseResponse"] = $6ceae2f28aadafe4$export$ba14d9a5a581e827;

});

parcelRegister("knAnv", function(module, exports) {

var $948ml = parcelRequire("948ml");


var $a4PNj = parcelRequire("a4PNj");


var $7DTQg = parcelRequire("7DTQg");


var $kTng4 = parcelRequire("kTng4");


var $4FjtR = parcelRequire("4FjtR");

function $76562595f5efb658$var$createOnceFlaggedHandlers() {
    return {
        increment: (0, (/*@__PURE__*/$parcel$interopDefault($948ml)))(()=>(0, $4FjtR.setCookie)((0, $7DTQg.REDIRECT_COUNT), (0, $kTng4.getCookieAsInteger)((0, $7DTQg.REDIRECT_COUNT)) + 1)),
        clear: (0, (/*@__PURE__*/$parcel$interopDefault($948ml)))(()=>(0, $a4PNj.clearCookie)((0, $7DTQg.REDIRECT_COUNT)))
    };
}
let $76562595f5efb658$var$handlers = $76562595f5efb658$var$createOnceFlaggedHandlers();
const $76562595f5efb658$export$3470529e7c6e2aa5 = {
    increment: ()=>$76562595f5efb658$var$handlers.increment(),
    clear: ()=>$76562595f5efb658$var$handlers.clear(),
    /**
   * Resets the once-ness of `increment` and `clear`. Used by tests so each case
   * starts from a clean redirect budget.
   */ resetOnceFlag: ()=>{
        $76562595f5efb658$var$handlers = $76562595f5efb658$var$createOnceFlaggedHandlers();
    }
};
module.exports["redirectCount"] = $76562595f5efb658$export$3470529e7c6e2aa5;

});

parcelRegister("cJ8tU", function(module, exports) {
const $63a05f6e1b1fd896$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $63a05f6e1b1fd896$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($63a05f6e1b1fd896$var$UUID_REGEX, '<UUID>');
};
module.exports["stripUUIDFromPath"] = $63a05f6e1b1fd896$export$6bd073e2c6dda996;

});

parcelRegister("a4PNj", function(module, exports) {
function $cbefcd4c9d71d1ef$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}
module.exports["clearCookie"] = $cbefcd4c9d71d1ef$export$ad3506281d5a5e5d;

});

parcelRegister("7DTQg", function(module, exports) {
const $7a4796077c357a3e$export$f6101897f0230549 = 'redirectCount';
const $7a4796077c357a3e$export$5a7d8afb87170e45 = 'avatar.csrf.token';
module.exports["REDIRECT_COUNT"] = $7a4796077c357a3e$export$f6101897f0230549;

});

parcelRegister("kTng4", function(module, exports) {
function $e9560ed5abe5f2a7$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
module.exports["getCookieAsInteger"] = $e9560ed5abe5f2a7$export$6a289e5003f59269;

});

parcelRegister("4FjtR", function(module, exports) {
function $b460839fce11b2fe$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
module.exports["setCookie"] = $b460839fce11b2fe$export$110700823644f4a6;

});


//# sourceMappingURL=TeamProfileCardEntryPoint.20efa9a4.js.map
